import { DEFAULT_TOOLTIP_POSITION } from './constants'
import { TooltipBoundaries, TooltipCoordinates, TooltipPosition, TooltipSize } from './types'

/**
 * Returns the boundaries of a tooltip based on its position and size.
 * This function calculates the top, left, right, and bottom boundaries
 */
const getPositionedTipBoundariesMap: Record<
  TooltipPosition,
  (tooltipSize: TooltipSize, tooltipPoint: TooltipCoordinates) => TooltipBoundaries
> = {
  top: (tooltipSize, tooltipPoint) => ({
    top: tooltipPoint.y - tooltipSize.height,
    left: tooltipPoint.x - tooltipSize.width / 2,
    right: tooltipPoint.x + tooltipSize.width / 2,
    bottom: tooltipPoint.y,
  }),
  bottom: (tooltipSize, tooltipPoint) => ({
    top: tooltipPoint.y,
    left: tooltipPoint.x - tooltipSize.width / 2,
    right: tooltipPoint.x + tooltipSize.width / 2,
    bottom: tooltipPoint.y + tooltipSize.height,
  }),
  left: (tooltipSize, tooltipPoint) => ({
    top: tooltipPoint.y - tooltipSize.height / 2,
    left: tooltipPoint.x - tooltipSize.width,
    right: tooltipPoint.x,
    bottom: tooltipPoint.y + tooltipSize.height / 2,
  }),
  right: (tooltipSize, tooltipPoint) => ({
    top: tooltipPoint.y - tooltipSize.height / 2,
    left: tooltipPoint.x,
    right: tooltipPoint.x + tooltipSize.width,
    bottom: tooltipPoint.y + tooltipSize.height / 2,
  }),
  right_bottom: (tooltipSize, tooltipPoint) => ({
    top: tooltipPoint.y - tooltipSize.height,
    left: tooltipPoint.x - tooltipSize.width,
    right: tooltipPoint.x,
    bottom: tooltipPoint.y,
  }),
  left_bottom: (tooltipSize, tooltipPoint) => ({
    top: tooltipPoint.y - tooltipSize.height,
    left: tooltipPoint.x,
    right: tooltipPoint.x + tooltipSize.width,
    bottom: tooltipPoint.y,
  }),
}

export const getPositionedTipBoundaries = ({
  position,
  tooltipSize,
  tooltipPoint,
}: {
  position: TooltipPosition
  tooltipSize: TooltipSize
  tooltipPoint: TooltipCoordinates
}): TooltipBoundaries => {
  const getBoundaries =
    getPositionedTipBoundariesMap[position] ||
    getPositionedTipBoundariesMap[DEFAULT_TOOLTIP_POSITION]

  return getBoundaries(tooltipSize, tooltipPoint)
}
